<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            DADOS CADASTRAIS -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <b-row>
                            <b-col sm="12" md="4" lg="2" xl="2">
                                <b-form-group>
                                    <label>CNPJ</label>
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            v-model="fornecedor.cpfCnpj"
                                            :disabled="desabilitarCampo"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="5" xl="5">
                                <b-form-group>
                                    <label>Razão Social</label>
                                    <b-form-input
                                        v-model="fornecedor.nome"
                                        :disabled="desabilitarCampo"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="5" xl="5">
                                <b-form-group>
                                    <label>Nome Fantasia</label>
                                    <b-form-input
                                        v-model="fornecedor.nomeFantasia"
                                        :disabled="desabilitarCampo"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="5" lg="5" xl="4">
                                <b-form-group>
                                    <label class="required">e-mail</label>
                                    <b-form-input
                                        type="text"
                                        v-model="fornecedor.email"
                                        @input="$v.fornecedor.email.$touch()"
                                        :state="
                                            $v.fornecedor.email.$error
                                                ? false
                                                : null
                                        "
                                    ></b-form-input>
                                    <b-form-invalid-feedback
                                        >Forneça um email
                                        válido</b-form-invalid-feedback
                                    >
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="3">
                                <b-form-group>
                                    <label>Telefone</label>
                                    <b-form-input
                                        maxlength="15"
                                        type="text"
                                        v-model="fornecedor.telefone"
                                        v-mask="[
                                            '(##) ####-####',
                                            '(##) #####-####'
                                        ]"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <h5 class="heading-1 mt-2">
                            <span>ENDEREÇO</span>
                        </h5>
                        <app-endereco-form
                            v-model="endereco"
                        ></app-endereco-form>
                    </b-card-body>
                    <b-card-footer>
                        <b-button
                            variant="primary"
                            @click.stop="confirmarSalvar()"
                            class="mr-2"
                            v-if="mostrarBtnSalvar"
                        >
                            <i class="fa fa-save"></i> Salvar
                        </b-button>
                        <b-button variant="danger" @click.stop="cancelar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Cancelar
                            </span>
                        </b-button>
                        <div class="float-right">
                            <label class="required ml-3 pt-2"></label>
                            <label class="ml-2 pt-2">Campos Obrigatórios</label>
                        </div>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required, email, minLength } from 'vuelidate/lib/validators'
import EnderecoForm from './../../../shared/components/EnderecoForm'
import DadosCadastraisServicos from './DadosCadastraisServicos'

export default {
    data() {
        return {
            fornecedor: {},
            endereco: {},
            operacao: 'ATUALIZAR',
            erros: []
        }
    },

    watch: {},

    created() {
        this.obterFornecedor()
    },

    methods: {
        cancelar() {
            this.$router.push({ name: 'FornecedorDadosCadastrais' })
        },

        obterFornecedor() {
            this.$store.dispatch('addRequest')
            DadosCadastraisServicos.obterDados().then(response => {
                if (response) {
                    if (response.success) {
                        this.fornecedor = response.data
                        this.normalizarFornecedor()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        normalizarFornecedor() {
            this.fornecedor.cpfCnpj = this.$maskCpfCnpj(this.fornecedor.cpfCnpj)
            this.fornecedor.telefone = this.$maskTelefone(
                this.fornecedor.telefone
            )
            this.fornecedor.cep = this.$maskCep(this.fornecedor.cep)
            this.endereco = {
                logradouro: this.fornecedor.logradouro.toUpperCase(),
                numero: this.fornecedor.numero,
                complemento: this.fornecedor.complemento
                    ? this.fornecedor.complemento.toUpperCase()
                    : this.fornecedor.complemento,
                bairro: this.fornecedor.bairro.toUpperCase(),
                cidade: this.fornecedor.cidade.toUpperCase(),
                uf: this.fornecedor.uf,
                cep: this.fornecedor.cep
            }
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Atualização Cadastral',
                html: `Confirma a solicitação para atualização cadastral?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let dadosCadastraisDto = {
                email: this.fornecedor.email,
                telefone: this.fornecedor.telefone.apenasNumeros(),
                logradouro: this.endereco.logradouro,
                numero: this.endereco.numero,
                complemento: this.endereco.complemento,
                bairro: this.endereco.bairro,
                cidade: this.endereco.cidade,
                uf: this.endereco.uf,
                cep: this.endereco.cep.apenasNumeros()
            }
            DadosCadastraisServicos.atualizar(dadosCadastraisDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso() {
            this.$swal({
                title: 'Solicitação de atualização realizada com sucesso',
                html: `Após o processamento da sua solicitação seus dados serão atualizados,
        na base de dados do SEBRAE.`,
                icon: 'success'
            }).then(result => {
                this.$emit('obterDadosCadastrais')
                this.cancelar()
            })
        }
    },

    computed: {
        mostrarBtnSalvar() {
            return !this.$v.$invalid && this.endereco.valido
        },

        desabilitarCampo() {
            return true
        }
    },

    validations: {
        fornecedor: {
            email: {
                required,
                email
            }
        }
    },

    components: {
        appEnderecoForm: EnderecoForm
    }
}
</script>
